'use client';

import { useParams } from 'next/navigation';
import { FEATURED_BRANDS } from '../_utils/Constants';
import { resolveBrandId } from '@/_lib/brand-href';

/**
 * Hook to get the active brand shipper UUID from the route.
 * Resolves brandSlug / where-to-go shipper segment → UUID.
 */
export function useActiveBrand(): string {
  const params = useParams()

  const segment = params?.brandSlug || params?.shipper || params?.id
  if (segment) {
    return resolveBrandId(String(segment))
  }
  return FEATURED_BRANDS.yaponamama
}
